/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiWindowNewDownRightIcon16Solid = forwardRef('UiWindowNewDownRightIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M2 10h1V6.5A2.5 2.5 0 0 1 5.5 4H12V3a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2Z" }),
        React.createElement("path", { d: "M6 14a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H6Z" })));
});
